import { terminalView } from '@fareye/configs'
import { Flex, styled } from '@fareye/ui'
import React from 'react'
import { Dropdown } from './../components/DropDown'
import { Timer } from './../components/Timer'
import { useTimer } from './../hooks/useTimer'
import { FaTruckSt } from './../../../style/styled'

const SearchSelectWrapper: any = styled.div`
  display: inline-block;
  width: 170px;
  height: fit-content;
  margin-right: 16px;
  @media (min-width: 3840px) {
    width: 560px;
    margin-right: 40px;
  }
`
const TerminalViewHeader: any = styled(Flex)`
  color: ${terminalView.darkTheme.textColor};
  height: 72px;
  align-items: center;
  margin-left: 16px;
  margin-right: 16px;
  @media (min-width: 1920px) and (max-width: 3840px) {
    margin-left: 50px;
    margin-right: 30px;
    height: 100px;
  }
  @media (min-width: 3840px) {
    margin-left: 130px;
    margin-right: 111px;
    height: 216px;
  }
`
export const Header = function(props: any) {
  const {
    optionsHub,
    setHub,
    setPageSize,
    optionsArrivalDeparture,
    setArrivalOrDeparture,
    setRefreshData,
    config
  } = props
  const [timer] = useTimer(
    setRefreshData,
    config?.page?.dataRefreshTimeInterval
  )
  const hubOptionsMenu = () => {
    if (!optionsHub.length) {
      return (
        <SearchSelectWrapper>
          <div style={{ padding: '4px', color: '#999', fontFamily: 'Roboto', fontSize: '14px' }}>
            No hubs available
          </div>
        </SearchSelectWrapper>
      )
    }
    return (
      <Dropdown
        options={optionsHub}
        setValue={setHub}
        setPageSize={setPageSize}
        style={{ marginRight: '16px' }}
      />
    )
  }
  const arrivalDepartureMenu = () => (
    <Dropdown
      options={optionsArrivalDeparture}
      setValue={setArrivalOrDeparture}
      setPageSize={setPageSize}
    />
  )
  return (
    <TerminalViewHeader>
      <FaTruckSt />
      {hubOptionsMenu()}
      {arrivalDepartureMenu()}
      <Timer>{timer}</Timer>
    </TerminalViewHeader>
  )
}
